import { render, staticRenderFns } from "./1InformationManagement.vue?vue&type=template&id=37af3b51&scoped=true&"
import script from "./1InformationManagement.vue?vue&type=script&lang=js&"
export * from "./1InformationManagement.vue?vue&type=script&lang=js&"
import style0 from "./1InformationManagement.vue?vue&type=style&index=0&id=37af3b51&scoped=true&lang=css&"
import style1 from "./1InformationManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af3b51",
  null
  
)

export default component.exports